import { baseRequest, fileRequest } from './base'

import store from '../vuex'
import Vue from 'vue'

/**
 * @desc 课表
 */
function getSchedule(params) {
  //如果选择了学校，加入学校字段
  if (store.getters.schoolId) {
    params = params ? params : {}
    params.schoolId = store.getters.schoolId
  }

  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaSchedule/'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 设置选课时间
 */
function setSelectCourseTime(params) {
  params.schoolId = store.getters.schoolId
  return baseRequest(`/api/pcWeb/teaSelectTime/createOrUpdate/`, 'post', params)
}

/**
 * @desc 查询上课时间段
 */
function getClassTimeList() {
  let tempUrl = '/api/pcWeb/teaClassTime/'
  let params = {}
  if (Vue.ls.get('schoolId')) {
    params.schoolId = Vue.ls.get('schoolId')
  }
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 设置上课时段
 */
function setToClassTime(params) {
  console.log(store.getters)
  if (store.getters.schoolId) {
    params.schoolId = store.getters.schoolId
  }
  return baseRequest(`/api/pcWeb/teaClassTime/create`, 'post', params)
}

/**
 * @desc 删除上课时段
 */
function deleteToClassTime(id) {
  return baseRequest(`/api/pcWeb/teaClassTime/delete/${id}`, 'get')
}

/**
 * @desc 查询学校选课时间
 */
function getSelectCourseTime(id) {
  let tempUrl = '/api/pcWeb/teaSelectTime/getSelectTime/'
  if (store.getters.schoolId) {
    tempUrl += `${store.getters.schoolId}`
  }
  return baseRequest(tempUrl, 'get')
}

/**
 * @desc 查询放假信息：信息 + 课表列表
 */
function getAfterSchool(id) {
  return baseRequest(`/api/pcWeb/teaSchedule/getAfterSchool/${id}`, 'get')
}

/**
 * @desc 放假 - 顺延
 */
function postpone(id) {
  return baseRequest(`/api/pcWeb/teaSchedule/postpone/${id}`, 'post')
}

/**
 * @desc 放假 - 修改课表
 */
function updateClassTime(id, params) {
  return baseRequest(`/api/pcWeb/teaSchedule/update/${id}`, 'post', params)
}

/**
 * @desc 更新学校配置 - 统一接口
 */
function createOrUpdateSetting(params) {
  if (store.getters.schoolId) {
    params.schoolId = store.getters.schoolId
  }
  return baseRequest(
    `/api/pcWeb/teaSchoolSetting/createOrUpdateSetting`,
    'post',
    params
  )
}

/**
 * @desc 查询学校配置 - 统一接口
 */
function getSetting() {
  return baseRequest(
    `/api/pcWeb/teaSchoolSetting/getSetting/${store.getters.schoolId}`,
    'get'
  )
}

/**
 * @desc 班级详情 - 班级信息+课节目录
 */
function getClassDetail(id) {
  return baseRequest(`/api/pcWeb/teaClass/getClassDetail/${id}`, 'get')
}

/**
 * @desc 学生点名列表
 */
function listStudentCheckin(id) {
  return baseRequest(`/api/pcWeb/teaClass/listStudentCheckin/${id}`, 'get')
}

/**
 * @desc 新增课节查询
 */
function newClassFestival(params) {
  return baseRequest(`/api/pcWeb/teaCourse/ResultClassTime/`, 'get', params)
  
}

// 补课
function makeUpMissedLessons(params) {
  return baseRequest(
    '/api/pcWeb/teaCourse/makeUpMissedLessons/',
    'post',
    params
  )
}

// 补课
function deleteClassRecording(params) {
  return baseRequest('/api/pcWeb/teaCourse/deleteLesson/', 'post', params)
}

/**
 * @desc 放假计划 - 获取放假计划列表
 */
function getLessonList(params) {
  return baseRequest(`/api/pcWeb/teaLessonPlanSetting/list`, 'post', params)
}

/**
 * @desc 放假计划 - 放假计划受影响的班级
 */
function affectedClass(params) {
  return baseRequest(
    'api/pcWeb/teaLessonPlanSetting/affectedClass',
    'post',
    params
  )
}

/**
 * @desc 放假计划 - 创建放假计划保存
 */
function createdLessonPlan(params) {
  return baseRequest('api/pcWeb/teaLessonPlanSetting/create', 'post', params)
}

/**
 * @desc 放假计划 - 修改放假计划保存
 */
function updateLessonPlan(params) {
  return baseRequest('api/pcWeb/teaLessonPlanSetting/update', 'post', params)
}

/**
 * @desc 放假计划 - 执行
 */
function executePlan(id, params) {
  return baseRequest(`api/pcWeb/teaLessonPlanSetting/implement/`, 'get', params)
}

/**
 * @desc 批量放假 - 获取时间列表
 */
function changeLessonPlan(id) {
  return baseRequest(`api/pcWeb/teaLessonPlanSetting/classCycle/${id}`, 'get')
}

/**
 * @desc 批量放假 - 确认按钮
 */
function affirmLessonPlan(params) {
  return baseRequest(
    `api/pcWeb/teaLessonPlanSetting/ChangeCourse`,
    'post',
    params
  )
}

/**
 * @desc 设置 - 应用到所有班级数据
 */
function getTermList() {
  return baseRequest(`api/pcWeb/teaSchoolSetting/listBureauTeaTerm`, 'get')
}

/**
 * @desc 设置 - 应用到所有班级  确定
 */
function applyToClassChooseCourseTime(params) {
  return baseRequest(
    `api/pcWeb/teaSchoolSetting/applyToClassChooseCourseTime`,
    'post',
    params
  )
}

/**
 * @desc 教务--总览，获取初始化学期
 */
function getTermAndSchoolList() {
  return baseRequest(`api/pcWeb/teaOverview/getTermAndSchoolList`, 'get')
}

/**
 * @desc 教务--总览，获取初始化表格
 */
function getTeachingOverview(params) {
  return baseRequest(
    'api/pcWeb/teaOverview/getTeachingOverview',
    'post',
    params
  )
}

/**
 * @desc 批量建班-获取学期列表
 */
function getClassTermList() {
  return baseRequest(`api/pcWeb/teaTerm/list`, 'get')
}

/**
 * @desc 批量建班-选择文件
 */
function checkFileInfo(params) {
  let id = { termId: params.termId }
  return fileRequest(`api/pcWeb/teaClass/classImport`, params, id)
}

/**
 * @desc 批量建班-导入预览
 */
function importPreview(params) {
  return baseRequest(
    `api/pcWeb/teaClass/classImportInfoValidation/`,
    'get',
    params
  )
}

/**
 * @desc 批量建班-确认导入
 */
function confirmImport(params) {
  return baseRequest(`api/pcWeb/teaClass/confirmImportClass/`, 'get', params)
}

/**
 * @desc 获取打印课表地址
 */
function printDailySchedule(id) {
  return baseRequest(`/api/pcWeb/teaSchedule/printDailySchedule/${id}`, 'get')
}

export default {
  getSchedule: getSchedule,
  setSelectCourseTime: setSelectCourseTime,
  getClassTimeList: getClassTimeList,
  setToClassTime: setToClassTime,
  deleteToClassTime: deleteToClassTime,
  getSelectCourseTime: getSelectCourseTime,
  getAfterSchool: getAfterSchool,
  postpone: postpone,
  updateClassTime: updateClassTime,
  createOrUpdateSetting: createOrUpdateSetting,
  getSetting: getSetting,
  getClassDetail,
  listStudentCheckin,
  makeUpMissedLessons: makeUpMissedLessons,
  deleteClassRecording,
  getLessonList,
  affectedClass,
  createdLessonPlan,
  updateLessonPlan,
  executePlan,
  changeLessonPlan,
  affirmLessonPlan,
  getTermList,
  applyToClassChooseCourseTime,
  getTermAndSchoolList,
  getTeachingOverview,
  getClassTermList,
  checkFileInfo,
  importPreview,
  confirmImport,
  printDailySchedule,
  newClassFestival
}
